module.exports = __webpack_public_path__ + "fonts/Courier-Bold.3bb83bb1.woff";